module.exports = __webpack_public_path__ + "static/media/map.455190c4.jpg";